import type { Product } from '../../../data/product';
import { preciseCurrencyFormatter } from '../../../helpers/format-currency';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const ExtendedCost: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Extended Cost',
  minWidth: 80,
  accessorFn: (product) => preciseCurrencyFormatter(product.inventory_qty * product.last_cost),
  toCSV: (product) => ({
    'Extended Cost': (product.inventory_qty * product.last_cost).toFixed(2),
  }),
});
